import { usePage } from "@inertiajs/react";
import { PropsWithChildren } from "react";
import { Navigation } from "../components/Navigtation";
import Layout from "./Layout";
import { ProfileNavigation } from "@/components/ProfileNavigation";
import { User } from "@/types/generated";
import { ApplicationBanner } from "@/components/ui/application-banner";

export default function AuthLayout({
  children,
}: PropsWithChildren) {
  const { auth } = usePage<{ auth?: { user: User } }>().props;

  return (
    <>
      <Navigation />
      <Layout>
        <ApplicationBanner />
        <div className="grid grid-cols-8 bg-neutral-50">
          {auth?.user && (
            <div className="col-span-8 lg:col-span-2 p-4 min-w-0">
              <ProfileNavigation />
            </div>
          )}
          <div className={auth?.user ? "col-span-8 lg:col-span-6" : "col-span-8"}>
            {children}
          </div>
        </div>
      </Layout>
    </>
  );
}
